import template from './approversTabComponent.html';

import './approversTabComponent.css';

class Controller {
	constructor(Api, modal) {
		'ngInject';

		this.modal = modal;
		this.Api = Api;
	}

	$onInit = async () => {
		this.users = await this.fetchUsers();

		this.roles = {
			prepend: [{ id: undefined, label: '-- Pick a Role for the Approver --', sort: -1 }],
			options: await this.fetchRoles(),
		};

		this.loadDefaultAssignment();

		this.approvers = [];
		this.dataTableColumns = [
			{ field: 'user', label: 'User', sortable: true },
			{ field: 'role', label: 'Role', sortable: true },
		];
		this.dataTableActions = [{ label: 'Delete', icon: 'trash2', callback: this.removeApprover }];
	};

	canAddApprover = () => {
		return this.assignment?.user && this.assignment?.role;
	};

	loadDefaultAssignment() {
		this.assignment = {
			user: undefined,
			role: undefined,
		};
	}

	addApprover = () => {
		try {
			if (!this.approvers.find(p => p.user_id === this.assignment?.user?.id)) {
				const role = this.roles.options.find(r => r.id === this.assignment?.role);

				this.approvers.push({
					user_id: this.assignment?.user?.id,
					contributor_duty_id: this.assignment?.role,
					email: this.assignment?.user?.email,
					user: this.assignment?.user?.name,
					role: role.label,
					subject: this.assignment?.subject || role.default_email_subject,
					message: this.assignment?.message || role.default_email_body,
				});

				this.loadDefaultAssignment();

				// the data table component only loads the data once, as a work around
				// we redefine this function to force a data refresh
				this.dataTableProvider = this.DataTableProvider();
			}
		} catch (error) {
			this.modal.alert({ escapedHtml: `<p>We ran into an error adding the approver</p>` });
		}
	};

	removeApprover = approver => {
		this.approvers = this.approvers.filter(p => p.user_id !== approver.user_id);

		// the data table component only loads the data once, as a work around
		// we redefine this function to force a data refresh
		this.dataTableProvider = this.DataTableProvider();
	};

	fetchUsers = async () => {
		try {
			const users = await this.Api.get(`/v2/users`);

			return users.map(user => {
				const label = `${user.fname_preferred || user.fname} ${user.lname_preferred || user.lname}`;
				return {
					id: user.id,
					name: label,
					email: user.email,
					$label: label,
					$search: `${user.id} ${label}`,
				};
			});
		} catch (error) {
			this.modal.alert({ escapedHtml: `<p>We ran into an error while fetching the users</p>` });
		}
	};

	onUserChange = user => {
		this.assignment.user = user;
	};

	fetchRoles = async () => {
		try {
			let response = await this.Api.get('/contributor_duties');

			return response
				.map(role => ({
					id: role.id,
					label: role.label,
					sort: role.sort,
					default_email_subject: role.default_email_subject,
					default_email_body: role.default_email_body,
				}))
				.sort((a, b) => a.sort < b.sort);
		} catch (error) {
			this.modal.alert({ escapedHtml: `<p>We ran into an error while fetching the roles</p>` });
		}
	};

	DataTableProvider = () => {
		this.onChange(this.approvers);

		return async () => ({
			data: this.approvers,
			total: this.approvers?.length,
		});
	};
}

const approversTabComponent = {
	bindings: {
		approvers: '<',

		onChange: '=',
	},
	controller: Controller,
	controllerAs: 'vm',
	template,
};

export default approversTabComponent;
